module.exports = __webpack_public_path__ + "img/search.db5d8122.svg";